import { Button } from "@deputy-ai/ui/button/Button";
import { type ComponentProps, useMemo } from "react";
import { RxLink1 } from "react-icons/rx";

export interface NextMessageLink {
  text: string;
  url: string;
}

export interface NextMessageContent {
  texts?: string[];
  links?: NextMessageLink[];
}

export type UiNextMessageProps = ComponentProps<"div"> & {
  nextMsgs: NextMessageContent[];
  onSendMessage: (message: string) => void;
};

export const UiNextMessage = (props: UiNextMessageProps) => {
  const { nextMsgs, onSendMessage } = props;

  const links = useMemo(
    () => nextMsgs.flatMap((nextMsg) => nextMsg.links ?? []),
    [nextMsgs]
  );

  const texts = useMemo(
    () => nextMsgs.flatMap((nextMsg) => nextMsg.texts ?? []),
    [nextMsgs]
  );

  return (
    <div className="flex flex-row flex-wrap gap-2 text-sm">
      {links.map((link, index) => (
        <a
          key={index}
          className={nextMessageLinkClassName}
          href={link.url}
          target="_blank"
          rel="noreferrer"
        >
          <RxLink1 />
          {link.text}
        </a>
      ))}
      {texts.map((text, index) => (
        <Button
          key={index}
          variant="outline"
          className="next-message h-7 rounded-full px-3 py-0.5 text-xs"
          onClick={() => onSendMessage(text)}
        >
          {text}
        </Button>
      ))}
    </div>
  );
};
const nextMessageLinkClassName =
  "next-message inline-flex items-center justify-center whitespace-nowrap text-xs font-medium transition-colors focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:opacity-50 border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground gap-x-2 px-3 py-0.5 h-7 rounded-full";
